import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.updateHREFs(window.location.hash);
  }

  updateHREFs(hash) {
    this.element.querySelectorAll("a").forEach((link) =>
      link.setAttribute("href", link.href.split("#")[0] + hash),
    );
  }
}
